module.exports = __webpack_public_path__ + "static/VFlogo-bb2c8b8de0c9d785ab04f3ace1e72516.png";